module.exports = "<div class=\"divClass row bg-software-gray-1 indexing-header\">\n  <div class=\"col-md-12 col-sm-12\">\n    <div class=\"p-1 hidden-sm-down\">\n      <h2 class=\"display-1 left-pad\">\n        Validate Loss Data Submission</h2>\n    </div>\n    <div class=\"p-1 hidden-md-up\">\n      <h2 class=\"display-3 left-pad\">\n        Validate Loss Data Submission</h2>\n    </div>\n  </div>\n</div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/validate-loss-data-submission/validate-loss-data-submission.component.html
// module id = ./src/app/modules/validate-loss-data-submission/validate-loss-data-submission.component.html
// module chunks = main